import * as angular from 'angular';
import {RzSlider} from 'angular';
import {CustomerFilter} from 'modules/customers/model/CustomerFilter';
import '../modal.scss';

interface Scope extends ng.IScope {
    filter: CustomerFilter;
    sliderOptions: RzSlider.RzOptions;

    clear(): void;

    cancel(): void;

    apply(): void;

    ready: boolean;
}

export class InterestRateModal {

    static instance = (
        ev: MouseEvent,
        filter: CustomerFilter,
        opts: RangeOptionsDto,
        parent: Element | string = document.body
    ): angular.material.IDialogOptions => ({

        template: require('./interest-rate-modal.html'),
        parent: angular.element(parent),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: false,

        controller: [
            '$scope', '$mdDialog', 'opts',
            function ($scope: Scope,
                      $mdDialog: angular.material.IDialogService,
                      opts: RangeOptionsDto) {

                $scope.filter = angular.copy(filter);
                $scope.ready = false;

                const floor = opts.minInterestRateAmount || 0;
                const ceil = opts.maxInterestRateAmount || 20;

                if ($scope.filter.minRate == null) $scope.filter.minRate = floor;
                if ($scope.filter.maxRate == null) $scope.filter.maxRate = ceil;

                $scope.sliderOptions = {
                    floor, ceil,
                    step: 0.125,
                    translate: (v: number) => `${v} %`,
                    enforceRange: true
                };

                $scope.clear = () => {
                    $mdDialog.hide({...$scope.filter, minRate: null, maxRate: null});
                };
                $scope.cancel = () => $mdDialog.cancel();
                $scope.apply = () => $mdDialog.hide(angular.copy($scope.filter));
            }
        ],

        onComplete: (scope: Scope) => {
            scope.ready = true;
            scope.$broadcast('rzSliderForceRender');
        },

        locals: {filter, opts}
    });
}

(InterestRateModal as any).$inject = ['$scope', '$mdDialog', 'opts'];
